var map = {
	"./about-lobby/about-lobby-1200.avif": 8862,
	"./about-lobby/about-lobby-1200.webp": 4088,
	"./about-lobby/about-lobby-480.avif": 1799,
	"./about-lobby/about-lobby-480.webp": 3861,
	"./about-lobby/about-lobby-768.avif": 1512,
	"./about-lobby/about-lobby-768.webp": 346,
	"./article-01-paperless/article-01-paperless-480.avif": 2309,
	"./article-01-paperless/article-01-paperless-480.webp": 1203,
	"./article-01-paperless/article-01-paperless-768.avif": 6726,
	"./article-01-paperless/article-01-paperless-768.webp": 2432,
	"./article-02-seamless/article-02-seamless-480.avif": 7351,
	"./article-02-seamless/article-02-seamless-480.webp": 9413,
	"./article-02-seamless/article-02-seamless-768.avif": 3416,
	"./article-02-seamless/article-02-seamless-768.webp": 5898,
	"./article-03-retrieval/article-03-retrieval-480.avif": 4823,
	"./article-03-retrieval/article-03-retrieval-480.webp": 7829,
	"./article-03-retrieval/article-03-retrieval-768.avif": 1832,
	"./article-03-retrieval/article-03-retrieval-768.webp": 9306,
	"./avatar-2/avatar-2-128.avif": 1828,
	"./avatar-2/avatar-2-128.webp": 1750,
	"./avatar-daniel/avatar-daniel-128.avif": 5102,
	"./avatar-daniel/avatar-daniel-128.webp": 9480,
	"./avatar-emily/avatar-emily-128.avif": 5556,
	"./avatar-emily/avatar-emily-128.webp": 2198,
	"./avatar-ethan/avatar-ethan-128.avif": 7472,
	"./avatar-ethan/avatar-ethan-128.webp": 8338,
	"./avatar-generic/avatar-generic-128.avif": 2326,
	"./avatar-generic/avatar-generic-128.webp": 8560,
	"./avatar-liam/avatar-liam-128.avif": 1070,
	"./avatar-liam/avatar-liam-128.webp": 952,
	"./avatar-mateo/avatar-mateo-128.avif": 6892,
	"./avatar-mateo/avatar-mateo-128.webp": 6766,
	"./avatar-sophia/avatar-sophia-128.avif": 3450,
	"./avatar-sophia/avatar-sophia-128.webp": 148,
	"./demo-valet-handover/demo-valet-handover-1200.avif": 8342,
	"./demo-valet-handover/demo-valet-handover-1200.webp": 4144,
	"./demo-valet-handover/demo-valet-handover-480.avif": 5519,
	"./demo-valet-handover/demo-valet-handover-480.webp": 3677,
	"./demo-valet-handover/demo-valet-handover-768.avif": 2832,
	"./demo-valet-handover/demo-valet-handover-768.webp": 402,
	"./hero-secondary/hero-secondary-1200.avif": 8494,
	"./hero-secondary/hero-secondary-1200.webp": 4344,
	"./hero-secondary/hero-secondary-1600.avif": 8762,
	"./hero-secondary/hero-secondary-1600.webp": 5924,
	"./hero-secondary/hero-secondary-2000.avif": 2347,
	"./hero-secondary/hero-secondary-2000.webp": 8297,
	"./hero-secondary/hero-secondary-480.avif": 9335,
	"./hero-secondary/hero-secondary-480.webp": 9813,
	"./hero-secondary/hero-secondary-768.avif": 3992,
	"./hero-secondary/hero-secondary-768.webp": 2506,
	"./how-01-checkin/how-01-checkin-480.avif": 3545,
	"./how-01-checkin/how-01-checkin-480.webp": 1063,
	"./how-01-checkin/how-01-checkin-768.avif": 8882,
	"./how-01-checkin/how-01-checkin-768.webp": 2924,
	"./how-02-ticket/how-02-ticket-480.avif": 6327,
	"./how-02-ticket/how-02-ticket-480.webp": 1237,
	"./how-02-ticket/how-02-ticket-768.avif": 40,
	"./how-02-ticket/how-02-ticket-768.webp": 9690,
	"./how-03-parked/how-03-parked-480.avif": 4911,
	"./how-03-parked/how-03-parked-480.webp": 3069,
	"./how-03-parked/how-03-parked-768.avif": 2224,
	"./how-03-parked/how-03-parked-768.webp": 3442,
	"./industry-convention/industry-convention-480.avif": 3659,
	"./industry-convention/industry-convention-480.webp": 8025,
	"./industry-convention/industry-convention-768.avif": 9044,
	"./industry-convention/industry-convention-768.webp": 2614,
	"./industry-hotels/industry-hotels-480.avif": 5303,
	"./industry-hotels/industry-hotels-480.webp": 9893,
	"./industry-hotels/industry-hotels-768.avif": 3848,
	"./industry-hotels/industry-hotels-768.webp": 2906,
	"./industry-malls/industry-malls-480.avif": 1849,
	"./industry-malls/industry-malls-480.webp": 4103,
	"./industry-malls/industry-malls-768.avif": 4338,
	"./industry-malls/industry-malls-768.webp": 1676,
	"./industry-restaurants/industry-restaurants-480.avif": 7267,
	"./industry-restaurants/industry-restaurants-480.webp": 5473,
	"./logo-mark/logo-mark-256.avif": 5414,
	"./logo-mark/logo-mark-256.webp": 4176,
	"./why-01-retrieval/why-01-retrieval-1200.avif": 26,
	"./why-01-retrieval/why-01-retrieval-1200.webp": 4660,
	"./why-01-retrieval/why-01-retrieval-480.avif": 1747,
	"./why-01-retrieval/why-01-retrieval-480.webp": 7169,
	"./why-01-retrieval/why-01-retrieval-768.avif": 4511,
	"./why-01-retrieval/why-01-retrieval-768.webp": 8574,
	"./why-02-experience/why-02-experience-1200.avif": 230,
	"./why-02-experience/why-02-experience-1200.webp": 2288,
	"./why-02-experience/why-02-experience-480.avif": 3967,
	"./why-02-experience/why-02-experience-480.webp": 3213,
	"./why-02-experience/why-02-experience-768.avif": 8784,
	"./why-02-experience/why-02-experience-768.webp": 7938,
	"./why-03-paperless/why-03-paperless-1200.avif": 9984,
	"./why-03-paperless/why-03-paperless-1200.webp": 6466,
	"./why-03-paperless/why-03-paperless-480.avif": 9001,
	"./why-03-paperless/why-03-paperless-480.webp": 1879,
	"./why-03-paperless/why-03-paperless-768.avif": 8850,
	"./why-03-paperless/why-03-paperless-768.webp": 108,
	"./why-illustration/why-illustration-82.avif": 3187,
	"./why-illustration/why-illustration-82.webp": 1633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5284;